import { render, staticRenderFns } from "./PointsList.vue?vue&type=template&id=3247ed4e&scoped=true"
import script from "./PointsList.vue?vue&type=script&lang=js"
export * from "./PointsList.vue?vue&type=script&lang=js"
import style0 from "./PointsList.vue?vue&type=style&index=0&id=3247ed4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247ed4e",
  null
  
)

export default component.exports